/**
 * GitLab OAuth scope strings are matched literally by Backstage.
 * `api` already grants read_api/read_repository, but GitLab tokens typically
 * list only `api` and `read_user`. Map the redundant names so CI/CD plugins
 * reuse the same session instead of opening a new login dialog.
 */
export function expandGitlabScopes(
  scope?: string | string[],
): string[] | undefined {
  if (scope === undefined) {
    return undefined;
  }

  const requested = Array.isArray(scope)
    ? scope
    : scope.split(/[ ,]+/).filter(Boolean);

  return Array.from(
    new Set(
      requested.map(item =>
        item === 'read_api' || item === 'read_repository' ? 'api' : item,
      ),
    ),
  );
}
